///////////////////////
// Church Center //////
import AttendeeMissingRequiredInfo from "sprinkles/church_center/attendee_missing_required_info"
import AddOnSelectionsFormCCW from "sprinkles/church_center/ccw_add_on_selections_form"
import ChurchCenterAttendeesEdit from "sprinkles/church_center/attendees_edit"
import WindowTitleToEventName from "sprinkles/church_center/window_title_to_event_name"
// These need to be initialized() immediately
import ChurchCenterRegistrationsShow from "sprinkles/church_center/registrations_show"
import CustomSelect from "sprinkles/church_center/custom_select"
import LoginMailCheck from "sprinkles/church_center/login_mail_check"
import ModalIdViewMonkeyPatch from "sprinkles/church_center/modal_id_view_monkey_patch"
import ToggleThis from "sprinkles/church_center/toggle_this"

///////////////////////
// Admin //////////////
import AddOnForm from "sprinkles/admin/add_on_form"
import DiscountsForm from "sprinkles/admin/discounts_form"
import EventCancelAttendees from "sprinkles/admin/event_cancel_attendees"
import EventLogoEdit from "sprinkles/admin/event_logo_edit"
import EventsArchive from "sprinkles/admin/events_archive"
import PersonImportModal from "sprinkles/admin/person_import_modal"
import RegistrationEditModal from "sprinkles/admin/registrations/edit"
import RegistrationsNewModal from "sprinkles/admin/registrations/new"
// These need to be initialized() immediately
import Charts from "sprinkles/admin/charts"
import ExpandableNavTabs from "sprinkles/admin/expandable_nav_tabs"
import Toggleable from "sprinkles/admin/toggleable"
import DataLink from "sprinkles/admin/data_link"

///////////////////////
// Shared /////////////
import AddOnSelectionsForm from "sprinkles/add_on_selections_form"
import BuildNestedAssociationButton from "sprinkles/build_nested_association_button"
import Checkbox from "sprinkles/checkbox"
import DestroyNestedAssociationButton from "sprinkles/destroy_nested_association_button"

const Sprinkles = {
  ChurchCenter: {
    AddOnSelectionsForm: AddOnSelectionsFormCCW,
    AttendeeMissingRequiredInfo,
    ChurchCenterAttendeesEdit,
    CustomSelect,
    WindowTitleToEventName,
    ToggleThis,
    initialize() {
      CustomSelect.initialize()
      LoginMailCheck.initialize()
      ModalIdViewMonkeyPatch.initialize()
      ToggleThis.initialize()
      ChurchCenterRegistrationsShow.initialize()
    }
  },
  Admin: {
    AddOnForm,
    AddOnSelectionsForm,
    DataLink,
    DiscountsForm,
    EventCancelAttendees,
    EventLogoEdit,
    EventsArchive,
    ExpandableNavTabs,
    PersonImportModal,
    RegistrationEditModal,
    RegistrationsNewModal,
    Toggleable,
    initialize() {
      Charts.initialize()
      ExpandableNavTabs.initialize()
      DataLink.initialize()
      Toggleable.initialize()
    }
  },
  Shared: {
    BuildNestedAssociationButton,
    Checkbox,
    DestroyNestedAssociationButton
  }
}

export default Sprinkles
